import { Component, Input, OnInit } from '@angular/core';
import { NavigationExtras, Router } from '@angular/router';
import { ModalController, Platform } from '@ionic/angular';
import { LoaderService } from 'src/app/services/loader.service';
import {
  AuthenticationStore,
  FaqResponse,
} from 'src/app/stores/authentication.store';
import { HelpTicketPage } from '../help-ticket/help-ticket.page';

@Component({
  selector: 'app-faqs-page',
  templateUrl: './faqs-page.page.html',
  styleUrls: ['./faqs-page.page.scss'],
})
export class FaqsPagePage implements OnInit {
  faqs: FaqResponse;
  skeleton: boolean = true;
  @Input() modalType: boolean = false;
  constructor(
    private auth: AuthenticationStore,
    public platform: Platform,
    private router: Router,
    private modalCtrl: ModalController
  ) {}

  async ngOnInit() {
    this.getFaq();
  }

  ionViewDidEnter() {
    this.getFaq();
  }
  async getFaq() {
    this.skeleton = true;
    this.faqs = await this.auth.getFaq();
    this.skeleton = false;
  }

  async dissmissModal() {
    await this.modalCtrl.dismiss();
  }
  async openHelp(type) {
    if (this.platform.is('mobile')) {
      var resp = await this.auth.requiredLogin();
      if (resp) {
        const navigationExtras: NavigationExtras = {
          state: {
            type: type,
          },
        };
        this.router.navigate(['/account/help-ticket'], navigationExtras);
      }
    } else {
      this.dissmissModal();
      var resp = await this.auth.requiredLogin();
      if (resp) {
        const modal = await this.modalCtrl.create({
          component: HelpTicketPage,
          cssClass: 'Successful-Created',
          componentProps: {
            pageType: type,
          },
        });
        modal.present();
      }
    }
  }
}
